import React from 'react';
interface BadgeProps {
  count: number;
  children: React.ReactNode;
}
export function Badge({
  count,
  children
}: BadgeProps) {
  return <div className="relative inline-flex" data-id="element-70">
      {children}
      {count > 0 && <span className="absolute -top-1 -right-1 flex h-4 w-4 items-center justify-center rounded-full bg-error text-[10px] font-bold text-white ring-2 ring-white" data-id="element-71">
          {count > 99 ? '99+' : count}
        </span>}
    </div>;
}